export const cardStyle = {
	cardPosition: {
		margin: '100px auto',
		width: '400px',
	},
	cardHeader: {
		background: '#d8085b',
		fontWeight: 'bold',

	}

};
export const errorStyle = {

	width: '100%',
	padding: '5px',
	background: '#F44336',
	textAlign: 'center',
	display: 'inline-block',

};

export const loadingStyle ={
	width: '100%',
	padding: '5px',
	background: '#d8085b',
	textAlign: 'center',
	color:'white',
	display: 'inline-block',
};

export const forgetBtnStyle = {
     paddingTop:'5px',
};